import { epoch, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';
import Address from '../address/Address';
import { YesNoOption } from '../global/YesNoOption.enum';
import type { IVerificationsIdentity } from './VerificationsIdentity.interface';

export default class VerificationsIdentity implements IVerificationsIdentity {
  idContact: string;
  option: YesNoOption;
  method: string;
  address: Address;
  date: number;

  static build = (data: IVerificationsIdentity) => new VerificationsIdentity(data);
  static blank = (idContact) => new VerificationsIdentity({ idContact });

  /**
   * Constructor
   * @param {IVerificationsIdentity} data
   */
  constructor(data?: IVerificationsIdentity) {
    this.idContact = toUUID(data?.idContact);
    this.option = YesNoOption.of(data?.option?.name);
    this.method = data?.method || '';
    this.address = new Address(data?.address);
    this.date = data?.date ? epoch(utc(data?.date)) : 0;
  }
}
